<template>
  <h2
    v-if="configData?.Header && configData.Header.length > 0"
    class="heading-xs py-24"
  >
    {{ configData.Header }}
  </h2>
  <PostPaidCardListing>
    <PostPaidCard
      v-for="(card, index) in sortedByAllowance"
      :key="index"
      :product="card"
    />
    <PostPaidCard
      v-if="configData?.FamilyCard"
      :product="familjPlanData"
      button-text="Läs mer"
      :card-icons="['users']"
      card-img="family"
      button-link="/familjeabonnemang"
    />
    <PostPaidCard
      v-if="configData?.LinkCard"
      :product="linkCardData"
      button-text="Se mobiler"
      :card-icons="['plus', 'phone-happy']"
      card-img="add-phone"
      button-link="/mobiltelefoner"
    />
  </PostPaidCardListing>
</template>

<script lang="ts" setup>
import type {
  ListingProduct,
  AggregatedBundlePriceDto,
} from '~/models/ListingProduct.api.model';
import { linkCardData } from '../../repository/static_data/staticSubscriptionPlans';

const store = useFamilyStore();

interface Props {
  configData?: {
    Data: ListingProduct[];
    FamilyCard?: boolean;
    BindingPeriod?: number;
    HasCampaign?: boolean;
    LinkCard?: boolean;
    Header: string | '';
  };
}

const props = defineProps<Props>();
const familyBundlePrice =
  store.getDefaultFamilyConnectionPlan?.bundlePrices.find(
    (bundlePrice) =>
      bundlePrice.BindingPeriod.Months === props.configData?.BindingPeriod,
  );
const familjPlanData = createFamiljPlanData(familyBundlePrice);

const sortedByAllowance = props.configData?.Data ?? [];

sortedByAllowance.sort((a, b) => {
  const valueA =
    a.Variants.at(0)?.Prices.BundlePrices?.at(0)?.Plan?.DataAllowance ?? 0;
  const valueB =
    b.Variants.at(0)?.Prices.BundlePrices?.at(0)?.Plan?.DataAllowance ?? 0;

  if (valueA < valueB) {
    return 1;
  } else if (valueA > valueB) {
    return -1;
  } else {
    return 0;
  }
});

function createFamiljPlanData(
  familyBundlePrice: AggregatedBundlePriceDto | undefined,
): ListingProduct {
  return {
    ProductId: 0,
    ProductAttributeCombinationId: 0,
    ProductName: 'Familj',
    ManufacturerName: '',
    Category: '',
    ShowOnHomePage: true,
    ShortDescription: [
      {
        Component: 'Text',
        Text: 'Halebop',
        FontWeight: 'normal',
      },
      {
        Component: 'SimpleBulletList',
        Items: [
          {
            Text: 'Alla kan vara familj',
          },
          {
            Text: 'Alla får sin egen surf',
          },
          {
            Text: '5G ingår',
          },
        ],
      },
    ],
    ReleaseDateLocal: new Date(),
    PopularityIndex: 0,
    Specifications: [],
    Categories: [],
    Variants: [
      {
        ProductAttributeCombinationId: 0,
        Images: [],
        Prices: {
          BundlePrices: familyBundlePrice ? [familyBundlePrice] : [],
        },
        ColorProductAttributeValueId: 0,
        StorageSize: '',
        Condition: '',
        StockQuantity: 0,
        Sku: '',
        StockQuantityDescription: '',
        DisplayOrder: 0,
        Color: {
          ColorName: '',
          Color: '',
        },
        DisableBuyButton: false,
      },
    ],
    Description: [],
    Seo: {
      Title: '',
      Keywords: '',
      Description: '',
    },
    ProductLinkUrl: '',
  };
}
</script>

<style scoped></style>
